export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20artistic%20flat%20lay%20of%20modern%20fashion%20accessories%20and%20lifestyle%20products%20arranged%20on%20a%20clean%20cream%20background%2C%20minimal%20composition%20with%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%20from%20left%20side%2C%20elegant%20product%20photography%20style%20with%20gentle%20shadows%2C%20no%20harsh%20contrasts%2C%20aesthetic%20and%20airy%20mood&width=1600&height=900&seq=hero-main-v9&orientation=landscape"
          alt="ItaobuySpreadsheet shopping guide - modern product discovery platform"
          title="ItaobuySpreadsheet – Smart Shopping Spreadsheet Platform"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-20 max-w-7xl mx-auto">
          <div className="lg:w-3/5">
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-background-50 leading-tight tracking-tight">
              Itaobuy<span className="text-primary-300">Spreadsheet</span>
              <br />
              <span className="font-light text-3xl md:text-4xl lg:text-5xl xl:text-6xl">Shopping Guide</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-200/90 max-w-xl leading-relaxed">
              The ultimate structured shopping spreadsheet system for smarter product discovery, effortless price comparison, and simplified online sourcing — all in one organized platform.
            </p>
            <div className="flex flex-wrap gap-4 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 text-sm md:text-base font-semibold bg-background-50 text-foreground-950 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore ItaobuySpreadsheet Now
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 text-sm md:text-base font-semibold border-2 border-background-50/60 text-background-50 rounded-full hover:bg-background-50/15 transition-all whitespace-nowrap cursor-pointer"
              >
                View Spreadsheet Guide
              </a>
            </div>
          </div>

          <div className="lg:w-2/5 flex flex-col gap-4">
            <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-2xl p-6">
              <p className="text-sm text-background-200/80 leading-relaxed">
                ItaobuySpreadsheet combines structured data, simplified navigation, and curated product listings — making it the go-to platform for thousands of online shoppers worldwide who want to save time and money on every purchase.
              </p>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-background-50">10K+</div>
                <div className="text-xs text-background-200/70 mt-1">Active Users</div>
              </div>
              <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-background-50">14</div>
                <div className="text-xs text-background-200/70 mt-1">Categories</div>
              </div>
              <div className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-background-50">60%</div>
                <div className="text-xs text-background-200/70 mt-1">Avg Savings</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}